// AUTHENTICATION

export const ACTIVITY_LOG = 'ACTIVITY_LOG';
export const ERROR_LOG = 'ERROR_LOG';

export const COMPANY = 'COMPANY';

export const CUSTOMER = 'CUSTOMER';
export const CUSTOMER_SEARCH = 'CUSTOMER_SEARCH';
export const CUSTOMER_MAPBOX_SEARCH = 'CUSTOMER_MAPBOX_SEARCH';
export const CUSTOMER_FROM_SEARCH = 'CUSTOMER_FROM_SEARCH';

export const ADDRESS = 'ADDRESS';
export const CONTACT = 'CONTACT';
export const EMPLOYEE = 'EMPLOYEE';
export const EMPLOYEES = 'EMPLOYEES';

export const DEPARTMENTS = 'DEPARTMENTS';
export const DEPARTMENT_TAGS = 'DEPARTMENT_TAGS';
export const JOB_CATEGORIES = 'JOB_CATEGORIES';

export const SERVICE_REQUEST = 'SERVICE_REQUEST';
export const SERVICE_REQUEST_MAPBOX_SEARCH = 'SERVICE_REQUEST_MAPBOX_SEARCH';
export const SERVICE_REQUESTS = 'SERVICE_REQUESTS';

export const INVOICE = 'INVOICE';
export const QUOTE = 'QUOTE';
export const QUOTES = 'QUOTES';
export const QUOTE_ATTACHMENTS = 'QUOTE_ATTACHMENTS';

export const ATTACHMENT = 'ATTACHMENT';
export const ATTACHMENTS = 'ATTACHMENTS';

export const CUSTOMER_INVOICES = 'CUSTOMER_INVOICES';

export const WORK_ORDER = 'WORK_ORDER';
export const WORK_ORDER_DRAG_START = 'WORK_ORDER_DRAG_START';
export const WORK_ORDER_DRAG_MOVE = 'WORK_ORDER_DRAG_MOVE';
export const WORK_ORDER_DRAG_END = 'WORK_ORDER_DRAG_END';
export const WORK_ORDER_ITEMS = 'WORK_ORDER_ITEMS';
export const WORK_ORDER_ATTACHMENTS = 'WORK_ORDER_ATTACHMENTS';
export const WORK_ORDER_INVOICES = 'WORK_ORDER_INVOICES';
export const WORK_ORDER_POPUP = 'WORK_ORDER_POPUP';
export const WORK_ORDERS = 'WORK_ORDERS';
export const WORK_ORDERS_INCOMPLETE = 'WORK_ORDERS_INCOMPLETE';

export const NEW_WORK_ORDER = 'NEW_WORK_ORDER';
export const NEW_WORK_ORDER_DRAG_START = 'NEW_WORK_ORDER_DRAG_START';
export const NEW_WORK_ORDER_DRAG_MOVE = 'NEW_WORK_ORDER_DRAG_MOVE';
export const NEW_WORK_ORDER_DRAG_END = 'NEW_WORK_ORDER_DRAG_END';

export const SETTINGS = 'SETTINGS';
export const SETTINGS_COMPANY = 'SETTINGS_COMPANY';
export const SETTINGS_ASSET_TYPES = 'SETTINGS_ASSET_TYPES';
export const SETTINGS_ASSET_CLASSIFICATION = 'SETTINGS_ASSET_CLASSIFICATION';
export const SETTINGS_PARTS_CATEGORIES = 'SETTINGS_PARTS_CATEGORIES';
export const SETTINGS_STOCK_PARTS = 'SETTINGS_STOCK_PARTS';
export const SETTINGS_GLOBAL = 'SETTINGS_GLOBAL';
export const SETTINGS_VERSION = 'SETTINGS_VERSION';
export const SETTINGS_TOGGLE_COLLAPSED = 'SETTINGS_TOGGLE_COLLAPSED';
export const SETTINGS_TOGGLE_STATUS_MODAL = 'SETTINGS_TOGGLE_STATUS_MODAL';
export const SETTINGS_UPDATE_STATUS_MODAL = 'SETTINGS_UPDATE_STATUS_MODAL';
export const UPDATE_BUTTON = 'UPDATE_BUTTON';

export const SERVICE_ITEM = 'SERVICE_ITEM';
export const SERVICE_ITEMS = 'SERVICE_ITEMS';
export const SERVICE_ITEM_CATEGORIES = 'SERVICE_ITEM_CATEGORIES';

export const USER = 'USER';
export const USER_SELECTED = "USER_SELECTED";
export const USER_LOCATIONS = 'USER_LOCATIONS';
export const USER_ACTIVATED = 'USER_ACTIVATED';
export const USERS = 'USERS';
export const USER_RECENT_ITEMS = 'USER_RECENT_ITEMS';

export const ARCHIVED_PROFILES = 'ARCHIVED_PROFILES';
export const ARCHIVED_SERVICE_REQUESTS = 'ARCHIVED_SERVICE_REQUESTS';
export const ARCHIVED_WORK_ORDERS = 'ARCHIVED_WORK_ORDERS';
export const ARCHIVED_SERVICE_ITEMS = 'ARCHIVED_SERVICE_ITEMS';

export const PROCUREMENT = 'PROCUREMENT';
export const PROCUREMENT_PRICING = 'PROCUREMENT_PRICING';
export const PROCUREMENT_SETTINGS = 'PROCUREMENT_SETTINGS';

export const LOGGING = 'LOGGING';

export const TRUCKING = 'TRUCKING';

export const VENDORS = "VENDORS";
export const VENDOR_SELECTED = "VENDOR_SELECTED";

export const ASSETS = "ASSETS";
export const ASSET_TYPE = "ASSET_TYPE";
export const ASSET_SELECTED = "ASSET_SELECTED";

export const STOCK_PARTS = "STOCK_PARTS";
export const STOCK_PART = "STOCK_PART";
export const STOCK_PART_SELECTED = "STOCK_PART_SELECTED";

export const PROFILE = 'PROFILE';
export const PROFILES = 'PROFILES';

export const MESSAGES = 'MESSAGES';

export const CONVERSATIONS = "CONVERSATIONS";
export const PRIVATE_MESSAGES = "PRIVATE_MESSAGES";
export const UNREAD_MESSAGES = "UNREAD_MESSAGES";

export const SEND_EMAIL = 'SEND_EMAIL';

export const REQUEST_OFF = 'REQUEST_OFF';
